"use client";

import useSession from "@/hooks/useSession";
import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
export default function SentryUser() {
  const session = useSession();
  useEffect(() => {
    if (session?.email) {
      const displayName = session.email.split("@")[0].split(".").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
      Sentry.setUser({
        email: session.email,
        username: displayName
      });
    } else {
      Sentry.setUser(null);
    }
  }, [session?.email]);
  return null;
}